//cspell:disable
import React from 'react';
import {
	Box,
	ComposableTypography,
	InputField,
	Spacer,
	Typography,
} from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { rem } from '@helpers';
import { Letter } from '@icons';
import { useDidMount, useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { saveUserInput, useIsOperator, useUserInput } from '@store';
import { useDispatch } from 'react-redux';
import { ValidationHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$helpers';
import { FormHelper } from '@bcp-channels-sharedcomponents-reactjs/form-utils/dist/helpers';

export const ChangeEmail: React.FC = () => {
	const t = useTranslation();
	const { email } = useUserInput();
	const dispatch = useDispatch();
	const isOperator = useIsOperator();
	const resources = {
		title: isOperator
			? t('placeholder.selectedPlan.operator.changeEmailCard.title')
			: t('placeholder.resume.changeEmailCard.title'),
		description: isOperator
			? t('placeholder.selectedPlan.operator.changeEmailCard.description')
			: t('placeholder.resume.changeEmailCard.description', { email: '' }),
		edit: isOperator ? t('general.shareEmail') : t('general.editEmail'),
		labelInput: t('general.email'),
		errorMessage: {
			required: t('general.errors.required'),
			invalidEmail: t('general.errors.invalidEmail'),
		},
	};

	const validateEmail = React.useCallback(
		(email?: string) => {
			return FormHelper.validateField(email, [
				ValidationHelper.validateRequired(resources.errorMessage.required),
				ValidationHelper.validateEmail(resources.errorMessage.invalidEmail),
			]);
		},
		[resources.errorMessage.invalidEmail, resources.errorMessage.required]
	);

	const errorMessage = React.useRef(validateEmail(email));

	const handleOnChangeEmail = React.useCallback(
		(value: string) => {
			errorMessage.current = validateEmail(value);
			const isValid = errorMessage.current === undefined;

			dispatch(saveUserInput({ email: value, isValid: isValid }));
		},
		[dispatch, validateEmail]
	);

	useDidMount(() => {
		const isValid = validateEmail(email) === undefined;

		dispatch(saveUserInput({ isValid: isValid }));
	});

	return (
		<>
			<Box
				styles={{
					width: '100%',
					flexDirection: 'column',
					padding: rem(24),
					borderRadius: rem(16),
					backgroundColor: '#FFFFFF',
					filter: 'drop-shadow(0px 2px 4px #E8EDF2)',
				}}
			>
				<Box>
					{!isOperator && (
						<Box styles={{ padding: rem(12, 8) }}>
							<Letter />
						</Box>
					)}
					<Box
						styles={{
							flexDirection: 'column',
							justifyContent: 'flex-start',
							marginLeft: rem(16),
						}}
					>
						<Box>
							<Typography appearance="body-100-04">{resources.title}</Typography>
						</Box>

						{!isOperator && (
							<>
								<Spacer vertical={8} />
								<Box>
									<ComposableTypography
										text={resources.description}
										baseProps={{
											appearance: 'body-75-02',
										}}
										tags={{
											b: { appearance: 'body-75-04' },
										}}
									/>
								</Box>

								<Spacer vertical={16} />

								<InputField
									label={resources.labelInput}
									value={email}
									onChangeValue={handleOnChangeEmail}
									bottomMessage={
										errorMessage.current
											? {
													text: {
														content: errorMessage.current,
													},
											  }
											: undefined
									}
									status={errorMessage.current ? 'error' : 'default'}
								/>
							</>
						)}
					</Box>
				</Box>
				{/* {!isOperator && (
					<Box
						styles={{
							justifyContent: 'flex-end',
							flexGrow: '1',
							alignItems: 'center',
						}}
					>
						<Link
							onClick={() => {
								show();
							}}
						>
							<Box>
								<Typography appearance="body-75-03" colorsLevel="linkDefault">
									{resources.edit}
								</Typography>
								{isOperator && (
									<>
										<Spacer horizontal={8} />
										<Edit fill={palette.primary.p1} width={rem(24)} height={rem(24)} />
									</>
								)}
							</Box>
						</Link>
					</Box>
				)} */}
			</Box>

			{/* <ChangeElectronicMail /> */}
		</>
	);
};
